var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14408_13244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 0.5H20.5001L7.5 19.4999H16.4999L29.5 0.5Z",
    fill: "#BF392C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H11.4999L24.4999 19.4999H15.5L2.5 0.5Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5C22.6 10.5 27.5 15.4 27.5 21.5C27.5 27.6 22.6 32.5 16.5 32.5C10.4 32.5 5.5 27.6 5.5 21.5C5.5 15.4 10.4 10.5 16.5 10.5Z",
    fill: "#ED9D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5C12.1001 13.5 8.5 17.1 8.5 21.5C8.5 25.9001 12.1 29.5001 16.5 29.5001C20.9001 29.5001 24.5001 25.9001 24.5001 21.5C24.5001 17.1 20.9 13.5 16.5 13.5ZM16.5 27.5C13.2 27.5 10.5001 24.7999 10.5001 21.5C10.5001 18.2001 13.2001 15.5001 16.5 15.5001C19.7999 15.5001 22.5 18.2001 22.5 21.5C22.5 24.7999 19.7999 27.5 16.5 27.5Z",
    fill: "#D58D54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14408_13244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBronze);
export default __webpack_public_path__ + "static/media/medalBronze.1b5e8d7aff0225a46d4e2694a3a6fd61.svg";
export { ForwardRef as ReactComponent };